/**
 * Cache to register access roles
 * @kind cache
 * @class AccessRoleLookup
 * @description Custom lookup cache for AccessRoleLookup
 * @usage let lookup = await Grape.cache.get('AccessRoleLookup');
 */
export default {
	name: 'AccessRoleLookup',
	options: {
		schema: 'grape',
		table: 'access_role',
		limit: 1000000,
		sortfield: 'role_name',
		sortorder: 'asc',
		filter: [{
			field: 'role_name',
			operand: 'IN',
			value: ['all', 'admin', 'guest', 'accountant', 'developer', 'director', 'employee', 'general_manager', 'manager', 'unverifed_user']
		}]
	}
};
